var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"body-wrap"}},[_c('LayoutHeader',{attrs:{"title":"실시간 도시 현황","color":"bg-red"}},[_c('ul',{staticClass:"category_list",attrs:{"slot":"navigator"},slot:"navigator"},[_c('li',[_vm._v("홈")]),_c('li',[_vm._v("실시간도시현황")])])]),_c('Realtime')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }